export default __webpack_public_path__ + "static/media/figma.5f41eaec.png";